
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/", function() {
      var page = require("/Users/andym/Development/Active/Website/pages/index.js")
      if(module.hot) {
        module.hot.accept("/Users/andym/Development/Active/Website/pages/index.js", function() {
          if(!next.router.components["/"]) return
          var updatedPage = require("/Users/andym/Development/Active/Website/pages/index.js")
          next.router.update("/", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  